import { createSelector } from "reselect"
import featureScopesSelector from "./featureScopesSelector"

const isDigitalGiveawayDealerIdIsRequiredSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('digitalGiveawayDealerIdIsRequired'),
)

export default isDigitalGiveawayDealerIdIsRequiredSelector
